import { render } from "./ResumeDetailsWizard.vue?vue&type=template&id=1cf5fcb5&scoped=true"
import script from "./ResumeDetailsWizard.vue?vue&type=script&lang=js"
export * from "./ResumeDetailsWizard.vue?vue&type=script&lang=js"

import "./ResumeDetailsWizard.vue?vue&type=style&index=0&id=1cf5fcb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf5fcb5"]])

export default __exports__